<template>
    <div id="game" :class="['futura',layoutProfile && layoutProfile.layout == 1 ? '' : 'game row', players ? 'playercount-'+players.length : '']">
        <template v-if="screentype =='bottom'">
            <game-asset-v-3-bottom-button></game-asset-v-3-bottom-button>
            <numpad :keyboardOnly="true" :disabledInput='disabledInput || !currentPlayer' :game_id="game.id" ref="numpad"></numpad>
        </template>
        <template v-else-if="layoutProfile">
            <div class="game2022">
                <!-- <debug-screen :data="mobs"></debug-screen> -->
                <div class="game-mainstage rpg-mainstage">
                    <div class="rpg-field">
                        <div class="hero">
                            <div class="heroPosition">
                                <dart-rpg-mob :mob="hero" v-if="hero != null" ref="heromob"></dart-rpg-mob>
                            </div>
                        </div>
                        <div :class="['enemyPosition', 'position_'+(i-1)]" v-for="i in 6" :key="i">
                            <dart-rpg-mob :mob="mobsAtPosition(i-1)" :key="'mobDisplay'+i"></dart-rpg-mob>
                        </div>
                    </div>
                    <div class="rpg-display-tohit">
                        <div class="toHitContainer">
                            <div class="toHitLabel">Zu treffen:</div>
                            <div class="toHitValue">{{toHit}}</div>
                        </div>
                        <div class="currentMobHealthContainer">
                            <div class="currentMobHealth">
                                <div class="enemyHealthBarOutline"></div>
                                <div class="enemyHealthBar" :style="'width: '+mobHealthBar()+'%'"></div>
                                <div class="currentMobHealthNumber">{{currentMobHealth}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="game-player-dart game-player-dart1">
                        <div :class="['game-player-dart-throw',colorCheck(singlescores, 0)]" v-html="singlescore(1)"></div>
                    </div>
                    <div class="game-player-dart game-player-dart2">
                        <div :class="['game-player-dart-throw',colorCheck(singlescores, 1)]" v-html="singlescore(2)"></div>
                    </div>
                    <div class="game-player-dart game-player-dart3">
                        <div :class="['game-player-dart-throw',colorCheck(singlescores, 2)]" v-html="singlescore(3)"></div>
                    </div>
                </div>
                <div class="game-players">
                    <game-asset-v-3-score-player v-for="player, idx in players" :playerIndex="idx" :playerId="player.player_id" :key="idx"></game-asset-v-3-score-player>
                </div>
                <numpad :keyboardOnly="true" :disabledInput='disabledInput || !currentPlayer' :game_id="game.id" ref="numpad"></numpad>
            </div>
        </template>
        <game-asset-v-3-stuck-dart></game-asset-v-3-stuck-dart>
        <game-asset-end-of-leg :game_prop="game" v-if="!game.winner_id"></game-asset-end-of-leg>
        <game-asset-statistics-v-2 :game_prop="game" v-if="game.winner_id"></game-asset-statistics-v-2>
        <game-asset-touchoverlay></game-asset-touchoverlay>
    </div>
</template>

<script>

import numpad from './gameAssets/gameAssetNumpadV2.vue';
import GameAssetScorePlayer from './gameAssets/gameAssetScorePlayer.vue';
import GameAssetGameHistory from './gameAssets/gameAssetGameHistory.vue';
import GameAssetDetermineStartPlayer from './gameAssets/gameAssetDetermineStartPlayer.vue';
import GameAssetVideoPlayer from './gameAssets/gameAssetVideoPlayer.vue';
import GameAssetStatistics from './gameAssets/gameAssetStatisticsSmall.vue';
import GameAssetGameResults from './gameAssets/gameAssetGameResults.vue';

import GameManagerV2 from './gameAssets/gameManagerV2';
import moment from 'moment';


//new
import GameAssetScoresSmall from './gameAssets/gameAssetScoresSmall.vue';
import GameManager from './gameAssets/gameManager';
import GameAssetV2ScorePlayer from './gameAssets/gameAssetV2ScorePlayer.vue';
import CpuOpponent from './CpuOpponent';
import GameAssetV3BottomButton from './v3/gameAssetV3BottomButton.vue';

export default {
    components: {
        numpad,
        GameAssetScorePlayer,
        GameAssetGameHistory,
        GameAssetDetermineStartPlayer,
        GameAssetVideoPlayer,
        GameAssetStatistics,
        GameAssetGameResults,
        GameAssetScoresSmall,
        GameAssetV2ScorePlayer,
        GameAssetV3BottomButton
    },
    props: ['game_prop', 'players_prop', 'logged_in_user', 'logged_in_player', 'webcamdata'],
    mixins: [],
    data() {
        return {
            game: this.game_prop,
            disabledInput: false,
            numpadTempScore: "",
            players: null,
            sendInputTimer: null,
            endOfLeg: false,
            endOfGame: false,
            currentPlayer: false,
            layoutProfile: null,
            showmenu: 'numpad',
            cputhrow: false,
            screentype: '',
            mobs: null,
            toHit: null,
            hero: {
                "spritesheet": "hero",
                "type": 0 //hero
            },
            herostate: "idle",
            currentMobHealth: 0,
            singlescores: [],
        }
    },
    created() {
        // create game manager object and read options
        this.gm = new GameManagerV2(this.game, this);
        window.logged_in_user = this.logged_in_user;
        this.screentype = window.name;
    },
    mounted() {
        this.layoutProfile = window.currentProfile ? window.currentProfile : { layout: 1, show_history: true, show_numpad: true };
        if (!this.layoutProfile.show_numpad && this.layoutProfile.show_history) this.showmenu = 'history';

        window.connection.subscribe(this);
        this.update(window.connection.lastUpdate);
    },
    methods: {
        update(data) {
            if (data == null) return;
            //update players from gamestate
            if (this.players == null) {
                this.players = data.players;
            }
            this.playerIndex = data.gameState.currentPlayerIndex;
            this.singlescores = data.gameState.scores[this.playerIndex].singlescores;
            this.mobs = data.gameState.mobs;
            this.currentMobHealth = data.gameState.currentMobHealth;
            this.currentMobMaxHealth = data.gameState.currentMobMaxHealth;

            this.toHit = data.gameState.tohit;
            // this.mobs = {
            //     ...this.mobs,
            //     ...{"lives": data.gameState.lives}
            // }

            //check if current player is the player in the browser
            this.currentPlayer = data.gameState.currentPlayer == this.logged_in_player || data.gameState.currentUser == this.logged_in_user;

            if (data.action == "endOfLeg" || data.action == "endOfGame") {
                this.disabledInput = true;
            }
            if (data.action == "newLegStart") {
                this.disabledInput = false;
            }
            if (data.action == "playerInputSingle") {
                this.animationCheck(this.singlescores[this.singlescores.length-1])
            }
        },
        showSubMenu(name) {
            this.showmenu = name;
        },
        singlescore(num) {
            if (this.singlescores) {
                if (this.singlescores[num - 1] && this.singlescores[num - 1]['str'] !== undefined)
                    return this.singlescores[num - 1]['str'];
                else if (this.singlescores[num - 1])
                    return this.singlescores[num - 1];
                else
                    return '<img src="/images/dart.png">';
            }
            return '<img src="/images/dart.png">';
        },
        colorCheck(data, number) {
            if (!data) return;
            if (data[number] !== undefined && data[number].success) return "success";
            if (data[number] !== undefined && data[number].missed === false) return "success";
            if (data[number] !== undefined && data[number].missed) return "miss";
            if (data[number] === undefined) return "open";
        },
        mobsAtPosition(pos) {
            if (this.mobs == null) return null;
            if (this.mobs[pos] != 0 && this.mobs[pos]) return this.mobs[pos];
            return null;
        },
        mobHealthBar() {
            var base = 79;
            return base * this.currentMobHealth / this.currentMobMaxHealth;
        },
        animationCheck(singlescore) {
            if (singlescore) {
                this.$refs.heromob.attack();
            }
        }
    }
}
</script>

<style scoped>

#game .game2022 .game-mainstage.rpg-mainstage {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 2fr 1fr auto;
    grid-template-areas:
        "rpg-field rpg-field rpg-field rpg-field rpg-field"
        ". tohit tohit tohit ."
        ". dart1 dart2 dart3 .";
    grid-column-start: 1;
    grid-column-end: 5;
}
.rpg-field {
    grid-area: rpg-field;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    background: rgb(2,0,36);
    background: linear-gradient(0deg, rgba(2,0,36,0) 0%, rgba(12,24,32,1) 10%, rgba(88,217,0,1) 45%, rgba(0,212,255,1) 50%, rgba(9,70,121,1) 100%);
    overflow: hidden;
}

.rpg-field .enemyPosition canvas {
    position: absolute;
}

.enemyPosition, .heroPosition {
    /* min-width: 342px; */
    min-height: 342px;
}

.heroPosition .hero-darts {
    margin-top: -5vh;
}

.rpg-display-tohit {
    grid-area: tohit;
    display: grid;
    grid-template-columns: 2fr 1fr;
}
.rpg-display-tohit > div {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.rpg-display-tohit .toHitContainer {
    background-image: url("/images/dartrpg/Menu_Middle.png");
    font-size: 4vw;
    line-height: 3.5vw;
    padding: 0.5vw 0;
    color: #ffffff;
    font-weight: bold;
}
.rpg-display-tohit .toHitContainer .toHitLabel {
    color: #c0123e;
    font-size: 2.5vw;
}
.rpg-display-tohit .currentMobHealthContainer {
    background-image: url("/images/dartrpg/HUD_Menu_Back.png");
    font-size: 5vw;
    justify-content: center;
    display: block;
}

.currentMobHealth {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    padding: 1vw 0 0 0;
}
.enemyHealthBar {
    background: rgb(2,0,36);
    background: linear-gradient(130deg, rgba(2,0,36,1) 0%, rgba(207,1,64,1) 40%, rgba(254,0,0,1) 100%);
    border-radius: 10px;
    border: 5px solid #000;
    grid-area: 1 / 1 / 2 / 2;
    margin: 1vw 2vw;
    width: 79%;
}
.enemyHealthBarOutline {
    background: rgb(2,0,36);
    border-radius: 10px;
    border: 5px solid #000;
    grid-area: 1 / 1 / 2 / 2;
    margin: 1vw 2vw;
}
.currentMobHealthNumber {
    grid-area: 1 / 1 / 2 / 2;
    text-align: center;
    color: #fff;
    font-weight: bold;
}
</style>
